var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenVulnerabilities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-triangle-alert h-6 w-6 text-orange-600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
    stroke: "#EA580C",
    fill: "none",
    strokeWidth: "2px"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9v4",
    stroke: "#EA580C",
    fill: "none",
    strokeWidth: "2px"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17h.01",
    stroke: "#EA580C",
    fill: "none",
    strokeWidth: "2px"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenVulnerabilities);
export default __webpack_public_path__ + "static/media/open-Vulnerabilities.3bac9a5f94959d1c2e9f6295b9eb0b85.svg";
export { ForwardRef as ReactComponent };